export const SectionLabel = ({ icon, title, showLive = false, showDay = false }) => {
  return (
    <div 
      className="flex items-center gap-3 pb-3 border-b-2 border-scoop-blue mb-7 fade-in"
      data-testid={`section-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <h2 className="text-[0.7rem] font-bold tracking-[0.13em] uppercase text-gray-800">
        {icon} {title}
      </h2>
      
      {showLive && (
        <span className="live-pill text-[0.62rem] font-bold tracking-wider uppercase bg-scoop-coral text-white px-2 py-0.5 rounded">
          Live
        </span>
      )}
      
      {showDay && (
        <span className="text-[0.62rem] font-bold tracking-wider uppercase bg-scoop-amber text-white px-2 py-0.5 rounded">
          Daily
        </span>
      )}
    </div>
  );
};

export default SectionLabel;
